export const salesLearnLeft = [
    {
        id: 1,
        text: "How to begin working as a UX Designer using Figma."
    },
    {
        id: 2,
        text: "How to implement colours & images properly in your designs."
    },
    {
        id: 3, 
        text: "How to create your own icons, buttons & other UI components"
    },
    {
        id: 4, 
        text: "Free UI kits & plugins for Figma which will speed up our workflow dramatically"
    },
    {
        id: 5, 
        text: "Learn professional workflow tricks & shortcuts"
    },
    {
        id: 6, 
        text: "Learn professional workflow tricks & shortcuts"
    }
]

export const salesLearnRight = [
    {
        id: 1, 
        text: "Learn to design websites & mobile phone apps."
    },
    {
        id: 2, 
        text: "Terms such as Components, Constraints & Multi Dimensional Variants."
    },
    {
        id: 3, 
        text: "Build a UX project from beginning to end"
    },
    {
        id: 4, 
        text: "A support community comprising of everyone who have taken this course"
    },
    {
        id: 5, 
        text: "Full time access to the course creator"
    },
]